<template>
    <skutopia>
        <!-- POG Header -->
        <div class="d-flex justify-space-between align-center flex-wrap gap-y-4 mb-6">
            <div>
                <div class="d-flex gap-2 align-center mb-2 flex-wrap">
                <h5 class="text-h5 mr-3">
                    {{localPOG.project}} - POG #{{ localPOG.id }}
                </h5>
                <div class="d-flex gap-x-2" v-if="localPOG.status">
                    <v-chip
                        :color="resolveStatus(localPOG.status).color"
                        small
                    >
                    {{ resolveStatus(localPOG.status).text }}
                    </v-chip>

                </div>
                </div>
                <div>
                <span class="text-body-1">
                    Created: {{formatDate(localPOG.created_at)}}
                </span>
                </div>
                <div>
                <span class="text-body-1">
                    Last updated: {{formatDate(localPOG.updated_at)}}
                </span>
                </div>
            </div>

            <v-btn
                outlined
                color="error"
                @click="isDeleteConfirmDialogVisible = !isDeleteConfirmDialogVisible"
                v-if="$can('update','skutopia')"
            >
                Delete POG
            </v-btn>
            </div>
                        <v-row>
                <v-col
                    cols="12"
                    md="12"
                >
                    <!-- 👉 POG Details -->
                    <v-card class="mb-6">

                        <v-card-title>
                            POG Details
                            <v-spacer></v-spacer>
                            <v-menu
                                bottom
                                left
                                v-if="$can('update','skutopia')"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                                </v-btn>
                                </template>

                                <v-list>
                                    <v-list-item
                                        @click="isPOGEdit = true"
                                    >    
                                        <v-list-item-title>
                                        <v-icon
                                            size="20"
                                            class="me-2"
                                        >
                                            {{ icons.mdiSquareEditOutline }}
                                        </v-icon>
                                        <span>Update POG Status</span>
                                        </v-list-item-title>
                                    </v-list-item>



                                    <!-- <v-list-item>
                                        <v-list-item-title>
                                            <v-icon
                                                size="20"
                                                class="me-2"
                                            >
                                                {{ icons.mdiLayersTripleOutline }}
                                            </v-icon>
                                            <span>Duplicate</span>
                                        </v-list-item-title>
                                    </v-list-item> -->
                                </v-list>
                            </v-menu>
                        </v-card-title>
                        <v-card-text>
                            <div class="d-flex align-center mb-2">
                                <v-avatar
                                    v-if="localPOG"
                                    size="34"
                                    color="primary"
                                    class="me-3"
                                >
                                    <span
                                    class="font-weight-medium white--text "
                                    >{{ avatarText(localPOG.created_by) }}</span>
                                </v-avatar>
                                <div>
                                    <div class="text-body-1 font-weight-medium">
                                    {{ localPOG.created_by }}
                                    </div>
                                    <span>Creator</span>
                                </div>
                            </div>

                            <div class="d-flex align-center mb-2">
                                <v-avatar
                                    color="success"
                                    size="34"
                                    class="me-3"
                                >
                                    <v-icon 
                                    size="20">{{ icons.mdiCartOutline }}</v-icon>
                                </v-avatar>

                                <div class="text-body-1 font-weight-medium">
                                    {{ productsData.length }} Products in the POG
                                </div>
                            </div>
                            <div class="d-flex align-center mb-2" v-if="missingProducts.length">
                                <v-avatar
                                    color="error"
                                    size="34"
                                    class="me-3"
                                >
                                    <v-icon
                                    size="20" dark>{{ icons.mdiCartOutline }}</v-icon>
                                </v-avatar>

                                <div class="text-body-1 font-weight-medium">
                                    {{ missingProducts.length }} Missing Products Images
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-text v-if="localPOG.comments">
                            Comments: 
                            <p>{{ localPOG.comments }}</p>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <!-- 👉 POG Shelf Image -->
            <v-card class="mb-6" :loading="imageLoading">
                <v-card-title>
                    Shelf Image Preview
                    <v-spacer></v-spacer>
                    <v-menu
                        bottom
                        left
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                        </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                @click="onFileChange"
                                v-if="$can('add','skutopia')"
                            >
                                <v-list-item-title>

                                    <!-- <v-file-input
                                        v-model="shelfImage"
                                        dense
                                        label="Select shelf image"
                                        accept="image/*"
                                        outlined
                                        @change="onFileChange"
                                        hide-input
                                        class="text-right ma-0 flex"
                                    >
                                    </v-file-input> -->
                                    <v-icon
                                        size="20"
                                        class="me-2"
                                    >
                                        {{ icons.mdiTrayArrowUp }}
                                    </v-icon>
                                    <span>Upload Shelf Image</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                @click="downloadShelf"
                            >
                                <v-list-item-title>
                                    <v-icon
                                        size="20"
                                        class="me-2"
                                    >
                                        {{ icons.mdiDownload }}
                                    </v-icon>
                                    <span>Download Shelf Img</span>
                                </v-list-item-title>
                            </v-list-item>

                        </v-list>
                    </v-menu>

            </v-card-title>

            <v-card-text>
                <v-img :src="localPOG.shelf_thumbnail" style="border: 1px dashed #ccc; min-height: 250px" />
            </v-card-text>
        </v-card>

        <!-- Product Details Card Grid -->
    <v-row>
      <v-col cols="12" md="12">
        <v-card class="mb-6">
          <v-card-title>
            Product Details
            <v-spacer></v-spacer>

             <!-- Toggle between list and card view -->
              
            <v-btn-toggle v-model="isCardView" dense>
            <v-btn :value="true" small class="d-flex justify-center align-center">
              <v-icon small class="mr-1">{{ icons.mdiViewGrid }}</v-icon>
            </v-btn>
            <v-btn :value="false" small class="d-flex justify-center align-center">
              <v-icon small class="mr-1">{{icons.mdiViewList}}</v-icon>
            </v-btn>
          </v-btn-toggle>



            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="isProductListEdit = true"
                v-if="$can('update','skutopia')">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiTrayArrowUp }}</v-icon>
                    <span>Upload Updated Product List</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadPOG">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiFormatListBulletedSquare }}</v-icon>
                    <span>Download POG File</span>
                  </v-list-item-title>
                </v-list-item>
                
                <v-list-item @click="downloadDocx">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiFileWordOutline }}</v-icon>
                    <span>Download Existing Images Docx</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadMissing">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiLocationExit }}</v-icon>
                    <span>Download Missing Products</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="isPNGDownload = true"
                >
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiDownload }}</v-icon>
                    <span>Download PNGs</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="downloadPSD"
                    v-if="$can('add','skutopia')">
                  <v-list-item-title>
                    <v-icon size="20" class="me-2">{{ icons.mdiImageAlbum }}</v-icon>
                    <span>Download PSD</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>

          <v-card-text>
          <!-- Card View -->
          <v-row dense v-if="isCardView">
            <v-col
              v-for="(item, index) in productsData"
              :key="index"
              cols="12"
              sm="6"
              md="3"
              lg="2"
            >
                <v-card outlined class="pa-3 d-flex flex-column justify-space-between h-100">
                  <div class="text-center mb-2">
                    <v-chip small color="info" outlined>{{ item.shelf_code || 'No Shelf Code' }}</v-chip>
                  </div>
                  <!-- Image with placeholder -->
                  <v-avatar
                    rounded = "0"
                    size="120"
                    class="mb-2 align-self-center"
                    v-if="item.product && item.product.images && item.product.images.length"
                    @click="openOverlay(item.product.images[0])"
                  >
                    <v-img
                      :src="item.product.images[0].thumbnail"
                      :alt="item.product.name"
                      contain
                    />
                  </v-avatar>

                  <!-- Placeholder when no image -->
                  <v-avatar size="120" class="mb-2 d-flex align-center justify-center mx-auto"  v-else>
                    <v-icon size="48" color="grey lighten-1">
                      {{icons.mdiCameraOff}}
                    </v-icon>
                  </v-avatar>


                  <!-- Product Name & Brand -->
                  <router-link :to="{ name: 'product-id', params: { id: item.product.barcode } }">
                    <div class="text-center mb-1">
                      <span class="font-weight-medium text-high-emphasis text-truncate d-block">{{ item.label }}</span>
                      <small class="text-muted">{{ item.product.brand.name }}</small>
                    </div>
                  </router-link>

                  <!-- Price -->
                  <div class="text-center mb-1">
                    <span class="font-weight-medium">{{ currencyFormatter.format(item.price) }}</span>
                  </div>

                  <!-- Stackings / Facings -->
                  <div class="d-flex justify-space-between mb-1">
                    <v-chip small outlined color="primary">{{ item.stackings }} stack</v-chip>
                    <v-chip small outlined color="secondary">{{ item.facings }} facings</v-chip>
                  </div>

                  <!-- Digital Switch -->
                  <div class="d-flex justify-center align-center mb-1">
                    <!-- <v-switch
                      v-model="item.digital"
                      @change="handleDigitalChange(item)"
                      dense
                      hide-details
                    ></v-switch> -->
                    <v-checkbox
                      v-model="item.digital"
                      @change="handleDigitalChange(item)"
                      dense
                      hide-details
                    />
                    <span class="ml-2 text-sm">Digital</span>
                  </div>

                  <!-- Last Uploaded -->
                  <div class="text-center text-xs text-muted">
                    <span v-if="item.product.images && item.product.images.length > 0">
                      Uploaded: {{ item.product.images[0].uploaded_at }}
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>

           <!-- List View -->
           <v-data-table
              v-else
              :headers="POGProductHeader"
              :items="productsData"
              item-value="productName"
              class="text-no-wrap"
              :loading="pogLoading"
              dense
              hide-default-footer
              disable-pagination
            >
                    <!-- <template #item.product="{ item }">
                    <div class="d-flex gap-x-3">

                        <div class="d-flex flex-column align-center">
                        <h6 class="text-h6">
                            {{ item.product.name }}
                        </h6>

                        <span class="text-sm text-start align-self-start">
                            {{ item.product.brand }}
                        </span>
                        </div>
                    </div>
                    </template> -->

                <template #item.product="{ item }">
                        <div class="d-flex align-center gap-x-4 cursor-pointer text-truncate"
                        >
                        <v-avatar
                            v-if="item.product.images && item.product.images.length > 0"
                            size="38"
                            rounded = "0"
                            class="mr-3"
                            @click="openOverlay(item.product.images[0])"
                        >
                            <v-img
                                :alt="item.product.name"
                                :src="item.product.images[0].thumbnail"
                                contain
                            ></v-img>
                        </v-avatar>
                        <router-link :to="{ name: 'product-id', params: { id: item.product.barcode } }">
                            <div class="d-flex flex-column">
                                <span class="text-high-emphasis font-weight-medium overflow-x-hidden">{{ item.label }}</span>
                                <a class="text-sm">{{ item.product.brand.name }}</a>
                            </div>
                        </router-link>
                        </div>

                </template>

                    <template #item.price="{ item }">
                        <span>{{ currencyFormatter.format(item.price) }}</span>
                    </template>

                    <template #item.stackings="{ item }">
                        <span>
                            {{ item.stackings }}
                        </span>
                    </template>

                    <!-- stock -->
                    <template #item.digital="{ item }">
                        <!-- <v-switch -->
                        <v-checkbox v-model="item.digital" @change="handleDigitalChange(item)"/>
                    </template>

                    <template #item.uploaded_at="{ item }">
                    <span v-if="item.product.images && item.product.images.length > 0">{{ item.product.images[0].uploaded_at }}</span>
                    </template>
                    <template #bottom />
                </v-data-table>
        </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- PNG Download Dialog -->
    <p-n-g-download-edit
      :is-dialog-edit.sync="isPNGDownload"
      :loading="downloadLoading"
      @download="downloadPNGs"
      @download-decipher="downloadDecipherPNGs"
    >
    </p-n-g-download-edit>

    <!-- Product List Edit Dialog -->
    <v-dialog v-model="isProductListEdit" width="400px" @click:outside="$emit('update:is-product-list-edit',false)">
      <v-card>
        <v-card-text>
          <div class="flex">
            <div class="w-full h-auto relative">
              <div ref="dropZoneRef" class="cursor-pointer" @click="() => openFile()">
                <div class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded">
                  <v-btn outlined color="secondary" class="rounded" size="30">
                    <v-icon size="24">{{ icons.mdiTrayArrowUp }}</v-icon>
                  </v-btn>
                  <span class="text-h6">Click to upload your POG File here.</span>
                </div>
                <div class="drop-zone" v-if="pogFiles.length > 0">
                  <v-list-item
                    v-for="(item, index) in pogFiles"
                    :key="index"
                    @click.stop
                  >
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
                    <template v-slot:append>
                      <v-list-item-action class="align-end">
                        <v-btn @click.stop="pogFiles.splice(index, 1)">X</v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined class="mr-2" @click="cancelProductListEdit">Cancel</v-btn>
          <v-btn color="primary" outlined :loading="planogramUploadLoading" @click="uploadProductList">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- POG Edit Dialog -->
    <v-dialog
        v-model="isPOGEdit"
        width="750px"
        @click:outside="$emit('update:isPOGEdit',false)"
    >
        <v-card>
            <v-card-title>Edit POG</v-card-title>
            <v-card-text>
                <v-select
                    v-model="localPOG.status"
                    :items="pogStatus"
                    label="Status"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                >

                </v-select>
                

                <v-textarea
                    v-model="localPOG.comments"
                    label="Comments"
                    rows="3"
                    outlined
                    dense
                    hide-details
                    placeholder="Comments"
                ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text outlined class="mr-2" @click="cancelPOGEdit">Cancel</v-btn>
                <v-btn color="primary" outlined :loading="planogramUploadLoading" @click="updatePOG">Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- POG Delete Dialog -->
    <v-dialog v-model="isDeleteConfirmDialogVisible" width="450px" @click:outside="$emit('update:is-delete-confirm-dialog-visible',false)">
      <v-card>
        <v-card-title>Delete POG Confirmation</v-card-title>
        <v-card-text>
          Do you want to delete the current POG?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined class="mr-2" @click="isDeleteConfirmDialogVisible = false">Cancel</v-btn>
          <v-btn color="error" outlined :loading="pogLoading" @click="deletePOGConfirmed(localPOG.id)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Image Overlay Dialog -->
    <v-dialog v-model="overlayOpen" width="80%">
      <v-card>
        <v-card-title>
          {{ selectedImage ? `${selectedImage.name} - ${selectedImage.side} - ${selectedImage.uploaded_at}` : '' }}
        </v-card-title>

        <v-img
          :src="selectedImage ? selectedImage.image : ''"
          :lazy_src="selectedImage ? selectedImage.thumbnail : ''"
          max-height="80vh"
          max-width="100%"
          contain
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular color="grey-lighten-4" indeterminate></v-progress-circular>
            </div>
          </template>
        </v-img>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeOverlay">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

        <p-n-g-download-edit
            :is-dialog-edit.sync="isPNGDownload"
            :loading="downloadLoading"
            @download="downloadPNGs"
            @download-decipher="downloadDecipherPNGs"
        >

        </p-n-g-download-edit>
        <v-dialog
            v-model="isProductListEdit"
            width="400px"
            @click:outside="$emit('update:is-product-list-edit',false)"
        >
            <v-card>
                <v-card-text>
                    <div class="flex">
                        <div class="w-full h-auto relative">
                        <div
                            ref="dropZoneRef"
                            class="cursor-pointer"
                            @click="() => openFile()"
                        >
                            <div
                            class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded"
                            >
                            <v-btn
                                outlined
                                color="secondary"
                                class="rounded"
                                size="30"
                            >
                                <v-icon
                                size="24"
                                >{{ icons.mdiTrayArrowUp }}</v-icon>
                            </v-btn>
                            <span class="text-h6">
                                Click to upload your POG File here.
                            </span>

                            </div>

                            <div class="drop-zone" v-if="pogFiles.length > 0"
                            >
                                <v-list-item
                                    v-for="(item, index) in pogFiles"
                                    :key="index"
                                    @click.stop
                                >
                                    <!-- File name -->
                                    <v-list-item-title>
                                        {{ item.name }}
                                    </v-list-item-title>
                                    <!-- File extension -->
                                    <v-list-item-subtitle>
                                        {{ item.type }}
                                    </v-list-item-subtitle>

                                    <template v-slot:append>
                                        <v-list-item-action class="align-end">
                                            <v-btn
                                            @click.stop="pogFiles.splice(index, 1)"
                                            >X</v-btn>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>

                            </div>
                        </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text outlined class="mr-2" @click="cancelProductListEdit">Cancel</v-btn>
                    <v-btn color="primary" outlined :loading="planogramUploadLoading" @click="uploadProductList">Upload</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="overlayOpen" width="80%">  <!-- Full-size image dialog -->
            <v-card>
                <v-card-title>
                {{ selectedImage ? `${selectedImage.name} - ${selectedImage.side} - ${selectedImage.uploaded_at}` : '' }}
                </v-card-title>

                <v-img
                    :src="selectedImage ? selectedImage.image : ''"
                    :lazy_src="selectedImage ? selectedImage.thumbnail : ''"
                    max-height="80vh"
                    max-width="100%"
                    contain
                >
                <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                    <v-progress-circular
                        color="grey-lighten-4"
                        indeterminate
                    ></v-progress-circular>
                    </div>
                </template>
                </v-img>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeOverlay">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </skutopia>
</template>

<script>
import router from '@/router'
import { onMounted, ref, watch, computed } from '@vue/composition-api'
import {
    mdiCartOutline,
    mdiDownload,
    mdiImageAlbum,
    mdiDotsVertical,
    mdiLayersTripleOutline,
    mdiSquareEditOutline,
    mdiTrayArrowUp,
    mdiLocationExit,
    mdiFileWordOutline,
    mdiViewGrid,
    mdiViewList,
    mdiCameraOff,
    mdiFormatListBulletedSquare
} from '@mdi/js';

import Skutopia from '@/views/apps/skutopia/Skutopia.vue'
import PNGDownloadEdit from './PNGDownloadEdit.vue'
import { useRouter, formatDate } from '@core/utils'
import { avatarText } from '@core/utils/filter'
import usePOG from '../usePOG'


export default {
    components: {
        Skutopia,
        PNGDownloadEdit
    },
    setup() {

        const localPOG =  ref({})

        const POGProductHeader = ref([
            {
                text: 'BAY',
                value: 'bay',
            },
            {
                text: 'CODE',
                value: 'shelf_code',
            },
            {
                text: 'PRODUCT',
                value: 'product'
            },
            {
                text: 'PRICE',
                value: 'price',
            },
            {
                text: 'FAC.',
                value: 'facings',
            },
            {
                text: 'STACK.',
                value: 'stackings',
            },
            {
                text: 'DEP.',
                value: 'depths',
            },
            {
                text: 'DIGITAL',
                value: 'digital',
            },
            {
                text: 'LAST UPLOADED',
                value: 'uploaded_at',
                sortable: false,
            }
        ])

        const { route } = useRouter()
        const shelfImage = ref(null)
        const currencyFormatter = ref(null)
        const isPNGDownload = ref(false)
        const isProductListEdit = ref(false)
        const pogFiles = ref([])
        const isPOGEdit = ref(false)
        const selectedImage = ref({})
        const overlayOpen = ref(false)
        const isCardView = ref(true)
        const isDeleteConfirmDialogVisible = ref(false)


        const {
            loadPOGData,
            planogram,
            pogStatus,
            downloadLoading,
            imageLoading,
            planogramUploadLoading,
            pogLoading,

            resolveStatus,
            addPOGShelfImage,
            fetchPOG,
            editPOG,
            deletePOG,
            downloadMissingProducts,
            downloadDOCXProducts,
            downloadPOGPSD,
            downloadPNG,
            downloadDecipherPNG,
            downloadPOGXLSX,
            updatePOGProduct
        } = usePOG()

        const init = () => {
            localPOG.value = JSON.parse(JSON.stringify(planogram.value))
            if (localPOG.value.products.length > 0) {
                currencyFormatter.value = new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: localPOG.value.products[0].currency
                })
            }
        }


        const productsData = computed(() => localPOG.value.products || [])
        const missingProducts = computed(() => localPOG.value.missing_images || [])
        const uploadShelfImage = async(file) => {
            const formImageData = new FormData()
            formImageData.append('shelf_image', file)
            const response = await addPOGShelfImage(localPOG.value.id, file)
            localPOG.value.shelf_thumbnail = response.shelf_thumbnail
        }

        // const onFileChange = (file) => {
        //     if (!file) {
        //         return;
        //     }
        //     uploadShelfImage(file);
        // }

        const downloadPSD = async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPOGPSD(pog)
        }

        const downloadPOG= async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPOGXLSX(pog)
        }

        const downloadPNGs = async (sides) => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadPNG(pog, sides)
        }


        const downloadDecipherPNGs = async (sides) => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            await downloadDecipherPNG(pog, sides)
        }
        

        const downloadMissing = async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            downloadMissingProducts(pog)
        }

        const downloadDocx = async () => {
            const pog = JSON.parse(JSON.stringify(localPOG.value))
            downloadDOCXProducts(pog)
        }

        const cancelProductListEdit = () => {
            pogFiles.value = []
            isProductListEdit.value = false
        }

        const uploadProductList = async () => {
            const payload = {
                excel_file: pogFiles.value[0]
            }

            localPOG.value = await editPOG(localPOG.value.id, payload)
            pogFiles.value = []
            isProductListEdit.value = false
        }

        const cancelPOGEdit = () => {
            isPOGEdit.value = false
        }

        const updatePOG = async() => {
            const payload = {
                status: localPOG.value.status,
                comments: localPOG.value.comments
            }

            localPOG.value = await editPOG(localPOG.value.id, payload)
            isPOGEdit.value = false
        }

        const handleDigitalChange = (pogProduct) => {
            const newPOGProduct = {
                id: pogProduct.id,
                digital: pogProduct.digital
            }
            updatePOGProduct(newPOGProduct)
        }


        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            input.onchange = _ => {
                // you can use this method to get file and perform respective operations
                pogFiles.value = Array.from(input.files);
                console.log(pogFiles.value);

            };
            input.click();
        }

        const downloadShelf = () => {

        }

        const onFileChange = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*'
            input.onchange = (_) => {
                // you can use this method to get file and perform respective operations

                const image = Array.from(input.files)[0];
                if (!image) {
                    return;
                }
                uploadShelfImage(image);

            };
            input.click();
        }


        const openOverlay = (image) => {
            selectedImage.value = image;
            overlayOpen.value = true;
        }

        const closeOverlay = () =>  {
            overlayOpen.value = false;
            selectedImage.value = null; // Clear the selected image
        }

        const deletePOGConfirmed = async(pog_id) => {
            await deletePOG(pog_id)
            router.push({
                name: 'planogram-list'
            })
        }

        onMounted(async () => {
            await fetchPOG(route.value.params.id)
        })


        watch(
            planogram,
            () => {
                init()
            }
        )

        return {
            localPOG,
            loadPOGData,
            POGProductHeader,
            productsData,
            missingProducts,
            imageLoading,
            shelfImage,
            downloadLoading,
            currencyFormatter,
            isProductListEdit,
            pogFiles,
            pogStatus,
            planogramUploadLoading,
            isPOGEdit,
            isPNGDownload,
            isDeleteConfirmDialogVisible,
            selectedImage,
            overlayOpen,
            pogLoading,
            isCardView,
            
            resolveStatus,
            cancelProductListEdit,
            downloadMissing,
            downloadDocx,
            downloadPSD,
            downloadPNGs,
            downloadDecipherPNGs,
            downloadPOG,
            downloadShelf,
            uploadProductList,
            closeOverlay,
            openOverlay,
            handleDigitalChange,
            cancelPOGEdit,
            updatePOG,
            deletePOGConfirmed,
            onFileChange,
            openFile,
            formatDate,
            avatarText,

            icons: {
                mdiCartOutline,
                mdiImageAlbum,
                mdiDotsVertical,
                mdiDownload,
                mdiLayersTripleOutline,
                mdiSquareEditOutline,
                mdiTrayArrowUp,
                mdiLocationExit,
                mdiFileWordOutline,
                mdiViewGrid,
                mdiViewList,
                mdiCameraOff,
                mdiFormatListBulletedSquare
            }
        }
    }
}
</script>

<style scoped>
    .text-high-emphasis {
        color: rgba(46, 38, 61, 0.9) !important;
    }

.v-file-input {
    grid-template-areas: none !important;
}
.v-input__prepend-outer {
    margin-top: 0px !important;
}

.drop-zone {
  border: 1px dashed rgba(33,33,33, 0.4);
}
</style>
